const replaceAt = (string, index, character) =>
  string.substr(0, index) + character + string.substr(index + character.length);

export default function capitalize(providedString, all = true) {
  if (providedString && typeof providedString === 'string') {
    const re = /\b([a-z])/g;
    let m;
    let returnString = providedString.toLowerCase();
    let isFirstCapitalized = false;
    do {
      m = re.exec(returnString);
      if (m) {
        if (!isFirstCapitalized || all) {
          returnString = replaceAt(returnString, m.index, m[0].toUpperCase());
          if (!all) isFirstCapitalized = true;
        }
      }
    } while (m && (!isFirstCapitalized || all));

    return returnString;
  }
  return null;
}
